import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';

import { ErknmActEventItemBodyProtocolFile } from './ErknmActEventItemBodyProtocolFile/ErknmActEventItemBodyProtocolFile';
import { ErknmActEventItemBodyProtocolsAppendicesToTheProtocolOfAction } from './ErknmActEventItemBodyProtocolsAppendicesToTheProtocolOfAction';
import { ErknmActEventItemBodyProtocolsStudiedDocuments } from './ErknmActEventItemBodyProtocolsStudiedDocuments';
import { IKnmErknmFormEventProtocol } from '../../../../../../MainModule/interfaces/IKnmErknmFormEventProtocol';

interface IErknmActEventItemBodyProtocolsProps {
  actIndex?: number;
  attachmentsNumber: number;
  eventFieldValueWithoutAction: boolean;
  eventId: string;
  eventIndex: number;
  formRef: IKnmFormRef | IDecisionFormRef | undefined;
  isDecision?: boolean;
  isPm?: boolean;
  isRequestForDocuments: boolean;
  name: string;
  protocolValue: IKnmErknmFormEventProtocol;
  watchOnly: boolean;
}

export const ErknmActEventItemBodyProtocol = ({
  actIndex,
  attachmentsNumber,
  eventFieldValueWithoutAction,
  eventId,
  eventIndex,
  formRef,
  isDecision,
  isPm,
  isRequestForDocuments,
  name,
  protocolValue,
  watchOnly,
}: IErknmActEventItemBodyProtocolsProps) => {
  return (
    <>
      {!eventFieldValueWithoutAction && (
        <ErknmActEventItemBodyProtocolFile
          actIndex={actIndex}
          name={`${name}.file.attachments`}
          isDecision={isDecision}
          isPm={isPm}
          eventIndex={eventIndex}
          formRef={formRef}
          isWatchOnly={watchOnly}
          attachmentsNumber={attachmentsNumber}
          eventId={eventId}
        />
      )}
      <ErknmActEventItemBodyProtocolsAppendicesToTheProtocolOfAction
        eventId={eventId}
        name={`${name}.appendicesToTheProtocolOfAction`}
        watchOnly={watchOnly}
        isDecision={isDecision}
      />
      {isRequestForDocuments && protocolValue.studiedDocuments && (
        <ErknmActEventItemBodyProtocolsStudiedDocuments
          eventId={eventId}
          name={`${name}.studiedDocuments`}
          studiedDocumentsValue={protocolValue.studiedDocuments}
          isDecision={isDecision}
        />
      )}
    </>
  );
};
